import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import Loading from 'layoutComponents/Loading';
import { isResidential, isComercial, isSingleFamily } from '../../utils/accountUtils';
import { ASURION_ENROLL_FLAG } from '../../constants/apiUrls';

const asurionServiceCodes = new Set([
  '9272',
  '9273',
  '9274',
  'EM9272',
  'EM9273',
  'EM9274'
]);

const asurionExcludedMarketIds = new Set([
  '60',
  '64'
]);

class AccountAddButtons extends React.PureComponent {

  constructor(props) {
    super(props);

    this.sendAsurionPlusCommunication = this
      .sendAsurionPlusCommunication
      .bind(this);
  }

  showAsurionPlusEnrollment() {
    if (!ASURION_ENROLL_FLAG) {
      return false;
    }

    const { packages, customerDetails, billingDetails, schedulingSystemDetails } = this.props;

    // Checks for X which stands for Greenfield.
    // If TRUE it won't show the <RaisedButton/>
    if(customerDetails.get('signalAccessCode') === "X") { 
        return false;
    }

    // if already has asurion, never show the button
    const hasAsurion = packages && packages.some(p => p.get('type') === 'SERVICECODE' && asurionServiceCodes.has(p.get('id').trim()));
    if (hasAsurion) {
      return false;
    }

    // if market id is not supported by asurion, dont show the button
    const marketId = schedulingSystemDetails && schedulingSystemDetails.get('marketId');
    if (asurionExcludedMarketIds.has(marketId)) {
      return false;
    }

    // if doesnt have assurion and is residential, show the button
    const customerType = customerDetails && customerDetails.get('customerType');
    if (isResidential(customerType)) {
      return true;
    }

    // if dont have assurion, is comercial but is single family, show the button
    const billTypeCode = billingDetails && billingDetails.get('billType');
    if (isComercial(customerType) && isSingleFamily(billTypeCode)) {
      return true;
    }

    // all other cases, dont show the button
    return false;
  }

  sendAsurionPlusCommunication() {
    const request = {
      assignedTechId: this.props.schedulingSystemDetails.get('technicianId'),
      customerEcid: this.props.customerDetails.get('ecid'),
    };
    const orderId = this.props.orderDetails.get('workOrderId');
    this.props.workOrderActions.asurionPlusEnrollmentSubmitStarted(request, orderId);
  }

  render() {
    const { accountAdd } = this.props;

    const isLoading = (accountAdd && accountAdd.get('loading')) || false;

    const buttons = [];

    if (this.showAsurionPlusEnrollment()) {
      buttons.push(<RaisedButton
        id="wow-fst-send-asurion-plus-communication"
        label="Send link to customer for Asurion Home+"
        disabled={isLoading}
        primary={true}
        onTouchTap={this.sendAsurionPlusCommunication}
        style={{
          marginTop: '10px',
          marginBottom: '10px',
          float: 'right',
          height: 'auto',
          maxWidth: '70%'
        }}
        buttonStyle={{
          minWidth: '100%',
          height: 'auto',
          padding: '10px 20px',
          textAlign: 'center'
        }}
        key={`accountAdd-button-${buttons.length}`}
      />);
    }

    return (
      <div style={{overflow: 'hidden'}}>
        <Loading isLoading={isLoading} />
        {buttons.map(b => b)}
      </div>
    );
  }
}

AccountAddButtons.propTypes = {
  orderDetails: PropTypes.object,
  customerDetails: PropTypes.object,
  billingDetails: PropTypes.object,
  schedulingSystemDetails: PropTypes.object,
  packages: PropTypes.object,
  workOrderActions: PropTypes.object,
  accountAdd: PropTypes.object,
};

export default AccountAddButtons;


// WEBPACK FOOTER //
// ./src/components/account/AccountAddButtons.js